import { APP_NAME, $document } from '../utils/environment';
import { module } from 'modujs';

const MODULE_NAME = 'Virtualgiftcard';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`
};

export default class extends module {
    constructor(options) {
        super(options);
        // Declaration of properties
        console.log('🔨 [module]:constructor - VirtualGiftCard');
    }
    init() {
        this.amount = 0;
        this.quantity = 1;
        this.from = '';
        this.to = '';
        this.tomail = '';
        this.tomailconfirm = '';
        this.message = '';
        this.el.querySelector('.js-from').$on('change',(el) => {this.from = this.el.querySelector('.js-from').value;})
        this.el.querySelector('.js-to').$on('change',(el) => {this.to = this.el.querySelector('.js-to').value;})
        this.el.querySelector('.js-tomail').$on('change',(el) => {this.tomail = this.el.querySelector('.js-tomail').value;})
        this.el.querySelector('.js-tomailconfirm').$on('change',(el) => {this.tomailconfirm = this.el.querySelector('.js-tomailconfirm').value;})
        this.el.querySelector('.js-message').$on('change',(el) => {this.message = this.el.querySelector('.js-message').value;})
        this.el.querySelector('.js-amount').$on('change',(el) => {this.amount = parseInt(this.el.querySelector('.js-amount').value,10);})

        this.el.$on('submit',(e) => {this.submit(e);})
    }

    submit(e) {
        e.preventDefault();
        if (this.tomail != this.tomailconfirm) {
            alert('Les 2 courriels ne correspondent pas, veuillez vérifier l\'ortographe.');
            return;
        }
        Snipcart.api.cart.items.add({
            id: 'VCC|'+this.amount,
            name: 'Carte cadeau virtuelle de '+this.amount+'$ pour '+this.to,
            price: this.amount,
            taxable: false,
            shippable: false,
            stackable: 'never',
            url: '/',
            image: '/app/uploads/2021/10/carte-cadeau-rsptc-960x637.png',/*CHANGE */
            quantity: this.quantity,
            maxQuantity: 1,
            metadata: {
                from: this.from,
                to: this.to,
                tomail: this.tomail,
                message: this.message
            }

        });
    }

    destroy() {
        console.log('❌ [module]:destroy - VirtualGiftCard');
        super.destroy()
    }
}
